module.exports = __webpack_public_path__ + "static/quiltedelephant-09afa4c01f76088c7de9845276717658.jpeg";